import { gql, useQuery } from '@apollo/client'
import { Link } from 'gatsby'
import { RecentBatchesQuery, RecentBatchesQueryVariables } from './__generated__/RecentBatchesQuery'

const recentBatchesQuery = gql`
  query RecentBatchesQuery($batchClass: String!) {
    recentBatches(batchClass: $batchClass) {
      id
      number
      status
      orders {
        totalCount
      }
    }
  }
`

const BatchList = ({ batchClass }: { batchClass: string }) => {
  const { loading, error, data } = useQuery<RecentBatchesQuery, RecentBatchesQueryVariables>(recentBatchesQuery, {
    variables: { batchClass },
  })

  if (loading) {
    return <div>Loading...</div>
  }

  if (error) {
    return <div>Error! {error.message}</div>
  }

  return (
    <table className="table is-bordered">
      <thead>
        <tr>
          <th>Number</th>
          <th>Status</th>
          <th>Orders</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {data.recentBatches.map((batch, i) => (
          <tr key={batch.id}>
            <td>{batch.number}</td>
            <td>
              {batch.status} {i === 0 && batch.status === 'OPEN' && <span className="tag is-info">Current</span>}
            </td>
            <td>{batch.orders.totalCount}</td>
            <td>
              <Link to={`/dashboard/batch/${batch.id}`}>details</Link>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default BatchList
